import type { IconProps } from './IconProps';

export const BluechipIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.996836 2.60889V4.21773L6.37985 4.22979L11.7629 4.24181V4.38379V4.52577L7.81138 4.55185C3.35008 4.58128 3.60586 4.56017 2.8247 4.96315C2.02493 5.37569 1.37575 6.16688 1.13218 7.02589C0.926986 7.7495 1.008 8.84145 1.31125 9.44022C1.77772 10.3612 2.55973 11.0062 3.54548 11.2831C3.89851 11.3822 4.00186 11.3853 7.83504 11.41L11.7629 11.4353L11.7777 11.5891L11.7925 11.7429H6.39405H0.995605L1.00805 13.3639L1.0205 14.9848L6.27338 14.9978C9.42307 15.0055 11.6778 14.9926 11.9048 14.9654C12.7309 14.8662 13.4135 14.5507 13.9613 14.0146C14.4882 13.499 14.776 12.9649 14.9355 12.2067C15.1662 11.1103 14.7758 9.89629 13.9322 9.0856C13.5659 8.73369 13.0011 8.41282 12.4722 8.25632C12.2126 8.17941 11.8539 8.17113 8.19891 8.1575L4.20909 8.14264L4.22376 7.99058L4.23848 7.83857L8.18997 7.81349C12.442 7.78651 12.2288 7.79887 12.9085 7.54051C13.4092 7.35027 14.0182 6.86096 14.3729 6.36371C14.7546 5.82874 15.0045 5.05728 15.0045 4.41361C15.0045 3.84925 14.7971 3.08115 14.5256 2.63979C14.0514 1.86914 13.301 1.30648 12.4606 1.09158C12.1167 1.0036 11.8852 1 6.54975 1H0.996836V2.60889Z"
      fill="currentColor"
    />
  </svg>
);
